import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import clazz from 'classnames';
import styles from './index.module.less';
export default function Banner(props) {
    const { className, style = {}, title, backgroundFixed, children, background, wrapperStyle = {}, playScale = 0.3, } = props;
    return (<div style={wrapperStyle}>
      <div key="banner-wrapper-div" className={clazz(styles.banner, className, {
        'banner-background-fixed': backgroundFixed,
    })} style={Object.assign({}, style, { backgroundImage: `url(${background})` })}>
        <OverPack playScale={playScale}>
          <QueueAnim delay={300} key="banner-wrapper">
            <QueueAnim delay={500} type="bottom" ease="easeOutQuart" key="children-wrapper" leaveReverse>
              {title && (<header>
                  <h1 key="main-title" className={clazz(styles.title)}>
                    {title[0]}
                  </h1>
                  <p key="sub-title" className={clazz(styles['sub-title'])}>
                    {title[1]}
                  </p>
                </header>)}

              <div key="extra-node-wrapper" className={clazz('bannel-container')}>
                {children}
              </div>
            </QueueAnim>
          </QueueAnim>
        </OverPack>
      </div>
    </div>);
}
